import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const LoginPage = () => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  });
  const [error, setError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    try {
      const response = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: formData.email, password: formData.password })
      });
      if (!response.ok) {
        throw new Error('Invalid credentials');
      }
      const data = await response.json();
      // Store user info in localStorage (or context)
      localStorage.setItem('user', JSON.stringify({
        isAuthenticated: true,
        role: data.role,
        token: data.access_token,
        username: formData.email
      }));
      window.location.href = '/members-area';
    } catch (err) {
      setError(err.message);
    }
  };

  return (
    <div className="container mx-auto py-10 px-6">
      <h1 className="text-3xl font-extrabold mb-6 text-black">{t('login')}</h1>
      <form onSubmit={handleSubmit} className="max-w-lg mx-auto">
        <div className="mb-4">
          <label className="block text-gray-900 font-extrabold mb-2">{t('Email Address')}</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="w-full border rounded-lg px-3 py-2"
            required
          />
        </div>
        <div className="mb-4">
          <label className="block text-gray-900 font-extrabold mb-2">{t('Password')}</label>
          <div className="relative">
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              className="w-full border rounded-lg px-3 py-2 pr-10"
              required
            />
            <button
              type="button"
              className="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 focus:outline-none"
              onClick={() => setShowPassword((prev) => !prev)}
              tabIndex={-1}
              aria-label={showPassword ? 'Hide password' : 'Show password'}
            >
              {showPassword ? (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13.875 18.825A10.05 10.05 0 0112 19c-5.523 0-10-4.477-10-10 0-1.657.403-3.221 1.125-4.575m1.875-2.425A9.956 9.956 0 0112 3c5.523 0 10 4.477 10 10 0 1.657-.403 3.221-1.125 4.575m-1.875 2.425A9.956 9.956 0 0112 21c-1.657 0-3.221-.403-4.575-1.125m-2.425-1.875A9.956 9.956 0 013 12c0-1.657.403-3.221 1.125-4.575m1.875-2.425A9.956 9.956 0 0112 3c1.657 0 3.221.403 4.575 1.125m2.425 1.875A9.956 9.956 0 0121 12c0 1.657-.403 3.221-1.125 4.575m-1.875 2.425A9.956 9.956 0 0112 21c-1.657 0-3.221-.403-4.575-1.125" /></svg>
              ) : (
                <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0zm-6.364 6.364A9.956 9.956 0 013 12c0-1.657.403-3.221 1.125-4.575m1.875-2.425A9.956 9.956 0 0112 3c5.523 0 10 4.477 10 10 0 1.657-.403 3.221-1.125 4.575m-1.875 2.425A9.956 9.956 0 0112 21c-1.657 0-3.221-.403-4.575-1.125m-2.425-1.875A9.956 9.956 0 013 12" /></svg>
              )}
            </button>
          </div>
        </div>
        {/* Show error if login fails */}
        {error && (
          <div className="text-red-600 font-bold mb-4">{error}</div>
        )}
        <button
          type="submit"
          className="bg-blue-600 text-white py-2 px-4 rounded-lg hover:bg-blue-700 transition font-extrabold"
        >
          {t('login')}
        </button>
      </form>
    </div>
  );
};

export default LoginPage;